import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { ListStore } from '../../store';
// 拉端
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { setAppQueryNoIfengsp } from '@src/utils/url';
import { devPath } from '@src/constants';
import { WxLaunchApp } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchApp/dynamic';

const Brand = ({ url = window.location.href, needPlaceHolder = true }) => {
    // 列表数据
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const { currentVideo, dramaSeries, positive } = listStates;
    const brandRef = useRef();

    // 设置端外分享栏高度
    useEffect(
        () => {
            if (brandRef.current) {
                const domRef = brandRef.current;

                changeListStates({
                    brandHeight: domRef.offsetHeight,
                });
            }
        },
        [brandRef],
    );

    const handleClick = (isJumpQQlink = false, isCallAppWx = true) => {
        let finalUrl = '';
        const positiveIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

        // 分享正片
        if (positiveIndex > -1) {
            finalUrl = setAppQueryNoIfengsp(`${devPath}/details/${dramaSeries.base62Id}?id=phmovie&ref=outside&type=other&backIndex=true&source=positive&positiveId=${currentVideo.base62Id}`);
        } else {
            // 分享花絮
            finalUrl = setAppQueryNoIfengsp(`${devPath}/details/${dramaSeries.base62Id}?id=phmovie&ref=outside&type=other&backIndex=true&source=gags&gagsId=${currentVideo.base62Id}`);
        }
        if (isCallAppWx) {
            callApp({
                docType: 'web',
                pid: finalUrl,
                kind: 'inter_da01',
                noKindFrom: 1,
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1512057577113',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8927',
                isJumpQQlink,
            });
        }
    };

    const SchemeLink = () => {
        let finalUrl = '';
        const positiveIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

        // 分享正片
        if (positiveIndex > -1) {
            finalUrl = setAppQueryNoIfengsp(`${devPath}/details/${dramaSeries.base62Id}?id=phmovie&ref=outside&type=other&backIndex=true&source=positive&positiveId=${currentVideo.base62Id}`);
        } else {
            // 分享花絮
            finalUrl = setAppQueryNoIfengsp(`${devPath}/details/${dramaSeries.base62Id}?id=phmovie&ref=outside&type=other&backIndex=true&source=gags&gagsId=${currentVideo.base62Id}`);
        }

        return getSchemeLink({
            docType: 'web',
            pid: finalUrl,
            kind: 'inter_da01',
            noKindFrom: 1,
        });
    };

    return !window.grounds ? (
        <div ref={brandRef}>
            {needPlaceHolder ? <div className={styles.placeholder} /> : null}
            <div className={styles.wrap} onClick={handleClick}>
                <div className={styles.wrapBtn}>立即打开</div>
                {/* <img className={styles.wrapLogo} src="https://x0.ifengimg.com/ucms/2023_44/31A0009714B77C212C710F60DBC83CB0AF8AAD57_size20_w750_h112.png" alt="" /> */}
                <WxLaunchApp launchType="app" launchAppClick={() => handleClick(false, false)} schemeLink={SchemeLink()} launchAppFail={() => handleClick(true, true)} />
            </div>
        </div>
    ) : null;
};

Brand.propTypes = {
    url: PropTypes.string,
    needPlaceHolder: PropTypes.bool,
};

export default errorBoundary(Brand);
